import { AfterViewChecked, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { faBan } from '@fortawesome/free-solid-svg-icons';
import { DataService, FlagService } from '@core/services';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'app-banner-juncture',
  templateUrl: './banner-juncture.component.html',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0 }),
        animate('500ms ease-in-out', style({ height: '*' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in-out', style({ height: 0 }))
      ])
    ])
  ],
  styleUrls: ['./banner-juncture.component.scss'],
  standalone: false
})
export class BannerJunctureComponent implements AfterViewChecked {

  @Input() imagePath: any;

  @ViewChild('fixInfoContainer') fixInfoContainer: ElementRef;

  public faBan = faBan;
  public contractorName = '';

  constructor(public dataService: DataService, public flagService: FlagService) { }

  ngAfterViewChecked(): void {
    this.dataService.hasEnglishVersion = JSON.parse(sessionStorage.getItem('HIPContract'))?.hasEnglishVersion;
    this.contractorName = JSON.parse(sessionStorage.getItem('HIPContract'))?.contractorName;
    const height = this.fixInfoContainer.nativeElement.offsetHeight;
    if (height) {
      this.dataService.fixInfoContainerHeight = height;
    }
  }

  public setLanguage(language: string, event): void {
    this.dataService.setLanguage(language);
    if (event) {
      event.cancelBubble = true;
      if (event.stopPropagation) {
        event.stopPropagation();
      }
    }
  }

}
